import {
    AAF_CONTENT_IS_NPVR,
    AAF_CONTENT_IS_VOD,
    AAF_CONTENT_IS_CATCHUP,
    AAF_CONTENT_IS_STARTOVER,
    AAF_CONTENT_IS_TV,
} from 'src/AAFPlayer/constants.js';

const CONTENT_TYPES_ON_LIVE: string[] = [
    AAF_CONTENT_IS_CATCHUP,
    AAF_CONTENT_IS_STARTOVER,
    AAF_CONTENT_IS_TV,
];
const CONTENT_TYPES_VOD: string[] = [AAF_CONTENT_IS_NPVR, AAF_CONTENT_IS_VOD];

interface IDefaultValuesModal {
    contentStreamType?: string;
    controlTime?: number;
    enable?: boolean;
    episodeNumber?: string | number;
    episodesCount?: number;
    group_id?: string;
    inactivityPath: {
        vod: string;
        npvr: string;
        live: string;
    };
    isSerie?: boolean;
    modalActiveTime?: number; //tiempo en minutos
    playing?: boolean;
    returnPath: {
        vod: string;
        npvr: string;
        live: string;
    };
    season_id?: string | null;
    series_id?: string | null;
    streamContentType?: string;
    timeEndStartOver?: number;
    totalEpisodes?: number;
    totalTimePlayer?: number; //tiempo en minutos
}

const DEFAULT_VALUES_REDUCE: IDefaultValuesModal = {
    contentStreamType: '',
    controlTime: 0,
    enable: false,
    episodeNumber: -1,
    episodesCount: 0,
    group_id: '',
    isSerie: false,
    modalActiveTime: 60, //tiempo en minutos
    playing: false,
    returnPath: {
        vod: '', //"/node/vcard/<group_id>"
        npvr: 'returnPath_npvr', //"/node/miscontenidos"
        live: 'returnPath_live', //"/node/homeuser"
    },
    inactivityPath: {
        vod: '', //"/node/vcard/<group_id>"
        npvr: 'inactivityPath_npvr', //"/node/miscontenidos"
        live: 'inactivityPath_live', //"/node/homeuser"
    },
    season_id: null,
    series_id: null,
    streamContentType: '',
    timeEndStartOver: 0,
    totalEpisodes: 4,
    totalTimePlayer: 240, //tiempo en minutos
};

export { CONTENT_TYPES_ON_LIVE, CONTENT_TYPES_VOD, DEFAULT_VALUES_REDUCE, IDefaultValuesModal };



// WEBPACK FOOTER //
// ./src/components/Modal/constants/ModalInactivity/constants.ts